module.exports = __webpack_public_path__ + "static/media/presentation_4.8e97fa96.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/presentation_4.svg
// module id = 656
// module chunks = 1